module.exports = __webpack_public_path__ + "static/fonts/iconfont.51d037e.woff";